import formatNumberCommas from 'Utils/formatNumberCommas'
import clsx from 'clsx'

interface Props {
	quantity: number
	unit: string
	isEdit?: boolean
}

const QuantityCell: React.FC<Props> = ({ quantity, unit, isEdit }) => {
	return (
		<div className="row justify-content-end text-end">
			<div
				className={clsx('col-12 text-kumopack-grey-900 fw-bold fs-4', {
					'text-kumopack-grey-900': !isEdit,
					'text-kumopack-grey-400 text-line-through': isEdit,
				})}>
				x {formatNumberCommas(quantity)}
			</div>
			<div className="col-12 text-kumopack-grey-600 fs-6" style={{ whiteSpace: 'nowrap' }}>
				{unit}
			</div>
		</div>
	)
}

export default QuantityCell
